var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    {
      staticClass: "sidebar-main hidden-print",
      class: { "sidebar-collapsed": _vm.isCollapsed },
      attrs: { id: "profile-sidebar" }
    },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-primary rounded sidebar-toggle",
          attrs: { type: "button" },
          on: { click: _vm.toggleCollapse }
        },
        [
          _c("font-awesome-icon", {
            attrs: {
              icon: _vm.isCollapsed ? "chevron-right" : "chevron-left",
              "aria-hidden": "true"
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "sr-only" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(
                  _vm.isCollapsed
                    ? _vm.$t("MAIN_CONTENT.SidePanel.sideMenuExpandLabel")
                    : _vm.$t("MAIN_CONTENT.SidePanel.sideMenuCollapseLabel")
                ) +
                "\n\t\t"
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mobile-rudder" },
        [
          _c(
            "a",
            {
              staticClass: "rudder-home",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.navigateToHomePage()
                },
                keydown: [
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.navigateToHomePage()
                  },
                  function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar"
                      ])
                    ) {
                      return null
                    }
                    $event.preventDefault()
                    return _vm.navigateToHomePage()
                  }
                ]
              }
            },
            [
              _c("font-awesome-icon", { attrs: { icon: "home" } }),
              _vm._v(" "),
              _c("span", { staticClass: "visible-lg-inline" }, [
                _vm._v(
                  _vm._s(_vm.$t("MAIN_CONTENT.commonContent.homeHeaderLink"))
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("MAIN_CONTENT.commonContent.currentHeaderLabel")
                  )
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-primary rounded sidebar-menu-toggle",
              attrs: { type: "button" },
              on: { click: _vm.toggleSmallMenu }
            },
            [
              _c("font-awesome-icon", {
                attrs: { icon: "bars", "aria-hidden": "true" }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "sr-only" }, [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(
                      _vm.$t("MAIN_CONTENT.SidePanel.sideMenuCollapseLabel")
                    ) +
                    "\n\t\t\t"
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("help-button", { attrs: { linkClass: "rudder-help" } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "relative-container",
          class: {
            "sidebar-collapsed": _vm.isCollapsed,
            "media-body":
              _vm.$route.path.includes("account-settings") && !_vm.isCollapsed
          },
          staticStyle: { width: "100%" }
        },
        [
          !!_vm.selectedStudent || _vm.$route.path.includes("account-settings")
            ? _c(
                "section",
                {
                  class: _vm.menuClassForSmall,
                  staticStyle: {
                    width: "100%",
                    "max-height": "100%",
                    "overflow-x": "hidden",
                    "overflow-y": "auto"
                  }
                },
                [
                  !_vm.isCollapsed
                    ? _c("h2", [
                        _c(
                          "span",
                          { class: [_vm.isCollapsed ? "sr-only" : ""] },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "MAIN_CONTENT.SidePanel.sideMenuMyBackpackHeader"
                                  )
                                ) +
                                "\n\t\t\t\t"
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "nav",
                    {
                      attrs: {
                        "aria-label": _vm.$t(
                          "MAIN_CONTENT.SidePanel.mainNavLabel"
                        )
                      }
                    },
                    [
                      _c(
                        "ul",
                        { staticClass: "sidebar-menu" },
                        [
                          !_vm.$route.path.includes("account-settings")
                            ? [
                                _vm.showRole("STUDENT_INFO_FLG")
                                  ? _c(
                                      "li",
                                      {
                                        class: {
                                          active:
                                            _vm.$route.path ===
                                            "/student-information"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeSmallMenu()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/student-information",
                                              title: _vm.$t(
                                                "MAIN_CONTENT.StudentInformation.sideMenuStudentInformationLink"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "sidebar-item-icon"
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "book-reader",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.isCollapsed
                                                    ? "sr-only"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.StudentInformation.sideMenuStudentInformationLink"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showRole("DATA_VERIFICATION_FLG")
                                  ? _c(
                                      "li",
                                      {
                                        class: {
                                          active:
                                            _vm.$route.path ===
                                            "/change-student-data"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeSmallMenu()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/change-student-data",
                                              title: _vm.$t(
                                                "MAIN_CONTENT.ChangeStudentData.sideMenuChangeStudentDataLink"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "sidebar-item-icon"
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "file-signature",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.isCollapsed
                                                    ? "sr-only"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.ChangeStudentData.sideMenuChangeStudentDataLink"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: {
                                      active:
                                        _vm.$route.path ===
                                        "/student-data-forms"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.closeSmallMenu()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: "/student-data-forms",
                                          title: _vm.$t(
                                            "MAIN_CONTENT.StudentDataForms.sideMenuStudentDataFormsLink"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "sidebar-item-icon" },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "clipboard",
                                                "aria-hidden": "true"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              _vm.isCollapsed ? "sr-only" : ""
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.StudentDataForms.sideMenuStudentDataFormsLink"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.showRole("CURRENT_SCHEDULE_FLG")
                                  ? _c(
                                      "li",
                                      {
                                        class: {
                                          active:
                                            _vm.$route.path ===
                                            "/current-schedule"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeSmallMenu()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                name: "CurrentSchedule",
                                                params: {}
                                              },
                                              title: _vm.$t(
                                                "MAIN_CONTENT.CurrentSchedule.sideMenuCurrentScheduleLink"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "sidebar-item-icon"
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "calendar-alt",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.isCollapsed
                                                    ? "sr-only"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.CurrentSchedule.sideMenuCurrentScheduleLink"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: {
                                      active:
                                        _vm.$route.path === "/student-calendar"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.closeSmallMenu()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "StudentCalendar",
                                            params: {}
                                          },
                                          title: _vm.$t(
                                            "MAIN_CONTENT.StudentCalendar.sideMenuStudentCalendarLink"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "sidebar-item-icon" },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "school",
                                                "aria-hidden": "true"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              _vm.isCollapsed ? "sr-only" : ""
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.StudentCalendar.sideMenuStudentCalendarLink"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.showRole("GRADES_FLG")
                                  ? _c(
                                      "li",
                                      {
                                        class: {
                                          active:
                                            _vm.$route.path ===
                                            "/courses-grades"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeSmallMenu()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/courses-grades",
                                              title: _vm.$t(
                                                "MAIN_CONTENT.CoursesAndGradesList.sideMenuCoursesAndGradesLink"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "sidebar-item-icon"
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "book",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.isCollapsed
                                                    ? "sr-only"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.CoursesAndGradesList.sideMenuCoursesAndGradesLink"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showRole("ASSESSMENTS_FLG")
                                  ? _c(
                                      "li",
                                      {
                                        class: {
                                          active:
                                            _vm.$route.path ===
                                            "/assessment-scores"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeSmallMenu()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/assessment-scores",
                                              title: _vm.$t(
                                                "MAIN_CONTENT.AssessmentScores.sideMenuAssessmentScoresLink"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "sidebar-item-icon"
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "align-center",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.isCollapsed
                                                    ? "sr-only"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.AssessmentScores.sideMenuAssessmentScoresLink"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showRole("INTERACTIVE_SCHEDULING_FLG")
                                  ? _c(
                                      "li",
                                      {
                                        class: {
                                          active:
                                            _vm.$route.path ===
                                            "/interactive-scheduler"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeSmallMenu()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/interactive-scheduler",
                                              title: _vm.$t(
                                                "MAIN_CONTENT.InteractiveScheduler.sideMenuInteractiveSchedulerLink"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "sidebar-item-icon"
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "hand-pointer",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.isCollapsed
                                                    ? "sr-only"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.InteractiveScheduler.sideMenuInteractiveSchedulerLink"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showRole("COURSE_REQUESTS_FLG") &&
                                _vm.courseRequestForms.length > 0
                                  ? _c(
                                      "li",
                                      {
                                        class: {
                                          active:
                                            _vm.$route.path ===
                                            "/course-request-forms"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeSmallMenu()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/course-request-forms",
                                              title: _vm.$t(
                                                "MAIN_CONTENT.SidePanel.sideMenuCourseRequestFormLink"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "sidebar-item-icon"
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "edit",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.isCollapsed
                                                    ? "sr-only"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.SidePanel.sideMenuCourseRequestFormLink"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showRole("ATTENDANCE_FLG")
                                  ? _c(
                                      "li",
                                      {
                                        class: {
                                          active:
                                            _vm.$route.path === "/attendance"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeSmallMenu()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/attendance",
                                              title: _vm.$t(
                                                "MAIN_CONTENT.Attendance.sideMenuAttendanceLink"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "sidebar-item-icon"
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "list-alt",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.isCollapsed
                                                    ? "sr-only"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.Attendance.sideMenuAttendanceLink"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showRole("DISCIPLINE_FLG")
                                  ? _c(
                                      "li",
                                      {
                                        class: {
                                          active:
                                            _vm.$route.path === "/discipline"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeSmallMenu()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/discipline",
                                              title: _vm.$t(
                                                "MAIN_CONTENT.Discipline.sideMenuDisciplineLink"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "sidebar-item-icon"
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "gavel",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.isCollapsed
                                                    ? "sr-only"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.Discipline.sideMenuDisciplineLink"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showFeesMenuItem()
                                  ? _c(
                                      "li",
                                      {
                                        class: {
                                          active: _vm.$route.path === "/fees"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeSmallMenu()
                                          }
                                        }
                                      },
                                      [
                                        _vm.district.CWP_ALLOW_PAYMENTS_FLG ===
                                        "N"
                                          ? [
                                              _c(
                                                "router-link",
                                                {
                                                  attrs: {
                                                    to: "/fees",
                                                    title: _vm.$t(
                                                      "MAIN_CONTENT.Fees.sideMenuFeesLink"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "sidebar-item-icon"
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "dollar-sign",
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      class: [
                                                        _vm.isCollapsed
                                                          ? "sr-only"
                                                          : ""
                                                      ]
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MAIN_CONTENT.Fees.sideMenuFeesLink"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          : _vm.studentHasSingleEnrollment ||
                                            _vm.webstores.length === 1
                                          ? [
                                              (!!_vm.preferences &&
                                                !!_vm.preferences.district &&
                                                !!_vm.preferences.district
                                                  .WEBSTORE_URL &&
                                                !!this.preferences.district
                                                  .WEBSTORE_PROVIDER) ||
                                              _vm.webstores.length === 1
                                                ? _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        target: "_blank",
                                                        href: _vm.buildVancoWebstoreUrl(
                                                          _vm.webstores[0]
                                                        ),
                                                        title: _vm.$t(
                                                          "MAIN_CONTENT.Fees.sideMenuFeesLink"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "sidebar-item-icon"
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon:
                                                                  "dollar-sign",
                                                                "aria-hidden":
                                                                  "true"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          class: [
                                                            _vm.isCollapsed
                                                              ? "sr-only"
                                                              : ""
                                                          ]
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "MAIN_CONTENT.Fees.sideMenuFeesLink"
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "aria-new-tab-message",
                                                        {
                                                          attrs: {
                                                            message: _vm.$t(
                                                              "MAIN_CONTENT.Accessibility.opensInNewTab"
                                                            )
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          : [
                                              _c(
                                                "button",
                                                {
                                                  class: [
                                                    "link-styled-nav-button",
                                                    {
                                                      "text-center":
                                                        _vm.isCollapsed
                                                    }
                                                  ],
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "MAIN_CONTENT.Fees.sideMenuFeesLink"
                                                    )
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setShowWebstoreModal(
                                                        true
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "sidebar-item-icon"
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "dollar-sign",
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      class: [
                                                        _vm.isCollapsed
                                                          ? "sr-only"
                                                          : ""
                                                      ]
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MAIN_CONTENT.Fees.sideMenuFeesLink"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showRole("LUNCH_FLG")
                                  ? _c(
                                      "li",
                                      {
                                        class: {
                                          active:
                                            _vm.$route.path === "/lunch-menus"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeSmallMenu()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                name: "LunchMenus",
                                                params: {}
                                              },
                                              title: _vm.$t(
                                                "MAIN_CONTENT.LunchMenus.lunchMenusLabel"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "sidebar-item-icon"
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "utensils",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.isCollapsed
                                                    ? "sr-only"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.LunchMenus.lunchMenusLabel"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showRole("GRAD_PROG_FLG")
                                  ? _c(
                                      "li",
                                      {
                                        class: {
                                          active:
                                            _vm.$route.path ===
                                            "/graduation-progress"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeSmallMenu()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/graduation-progress",
                                              title: _vm.$t(
                                                "MAIN_CONTENT.GraduationProgressReport.sideMenuGraduationProgressLink"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "sidebar-item-icon"
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: "graduation-cap",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.isCollapsed
                                                    ? "sr-only"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.GraduationProgressReport.sideMenuGraduationProgressLink"
                                                      )
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showRole("REPORTS_FLG")
                                  ? _c(
                                      "li",
                                      {
                                        staticClass: "treeview",
                                        class: {
                                          active: _vm.$route.path === "/reports"
                                        }
                                      },
                                      [
                                        _c(
                                          "button",
                                          {
                                            class: [
                                              "link-styled-nav-button",
                                              { "text-center": _vm.isCollapsed }
                                            ],
                                            attrs: {
                                              title: _vm.$t(
                                                "MAIN_CONTENT.SidePanel.sideMenuReportsLink"
                                              ),
                                              "aria-expanded": _vm.expandReports.toString(),
                                              "aria-controls": "reports-submenu"
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                $event.stopPropagation()
                                                return _vm.openReportsMenu(
                                                  $event
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "sidebar-item-icon"
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: _vm.expandReports
                                                      ? "folder-open"
                                                      : "folder",
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.isCollapsed
                                                    ? "sr-only"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.SidePanel.sideMenuReportsLink"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                                _c("font-awesome-icon", {
                                                  attrs: {
                                                    icon: _vm.expandReports
                                                      ? "chevron-up"
                                                      : "chevron-down"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.expandReports
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "treeview-menu",
                                                class: {
                                                  active: _vm.expandReports
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "inner-menu" },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.expandReportsMenu()
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon:
                                                                "chevron-left",
                                                              "aria-hidden":
                                                                "true"
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "MAIN_CONTENT.SidePanel.navPanelReports"
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "ul",
                                                      {
                                                        staticStyle: {
                                                          "list-style-type":
                                                            "unset"
                                                        },
                                                        attrs: {
                                                          id: "reports-submenu"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "li",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.closeSmallMenu()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "router-link",
                                                              {
                                                                attrs: {
                                                                  to:
                                                                    "/report-cards",
                                                                  title: _vm.$t(
                                                                    "MAIN_CONTENT.ReportFiles.navPanelReportCards"
                                                                  ),
                                                                  "aria-label": _vm.$t(
                                                                    "MAIN_CONTENT.ReportFiles.navPanelReportsSubMenuReportCards"
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "sidebar-item-icon"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "font-awesome-icon",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "file",
                                                                          "aria-hidden":
                                                                            "true"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "MAIN_CONTENT.ReportFiles.navPanelReportCards"
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "li",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.closeSmallMenu()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "router-link",
                                                              {
                                                                attrs: {
                                                                  to:
                                                                    "/progress-reports",
                                                                  title: _vm.$t(
                                                                    "MAIN_CONTENT.ReportFiles.navPanelProgressReports"
                                                                  ),
                                                                  "aria-label": _vm.$t(
                                                                    "MAIN_CONTENT.ReportFiles.navPanelReportsSubMenuProgressReports"
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "sidebar-item-icon"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "font-awesome-icon",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "file",
                                                                          "aria-hidden":
                                                                            "true"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "MAIN_CONTENT.ReportFiles.navPanelProgressReports"
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "li",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.closeSmallMenu()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "router-link",
                                                              {
                                                                attrs: {
                                                                  to:
                                                                    "/transcript",
                                                                  title: _vm.$t(
                                                                    "MAIN_CONTENT.ReportFiles.navPanelTranscript"
                                                                  ),
                                                                  "aria-label": _vm.$t(
                                                                    "MAIN_CONTENT.ReportFiles.navPanelReportsSubMenuTranscript"
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "sidebar-item-icon"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "font-awesome-icon",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "file",
                                                                          "aria-hidden":
                                                                            "true"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "MAIN_CONTENT.ReportFiles.navPanelTranscript"
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "li",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.closeSmallMenu()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "router-link",
                                                              {
                                                                attrs: {
                                                                  to:
                                                                    "/letters",
                                                                  title: _vm.$t(
                                                                    "MAIN_CONTENT.ReportFiles.navPanelLetters"
                                                                  ),
                                                                  "aria-label": _vm.$t(
                                                                    "MAIN_CONTENT.ReportFiles.navPanelReportsSubMenuLetters"
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "sidebar-item-icon"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "font-awesome-icon",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "file",
                                                                          "aria-hidden":
                                                                            "true"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "MAIN_CONTENT.ReportFiles.navPanelLetters"
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "li",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.closeSmallMenu()
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "router-link",
                                                              {
                                                                attrs: {
                                                                  to:
                                                                    "/file-cabinet",
                                                                  title: _vm.$t(
                                                                    "MAIN_CONTENT.FileCabinet.navPanelFileCabinet"
                                                                  ),
                                                                  "aria-label": _vm.$t(
                                                                    "MAIN_CONTENT.FileCabinet.navPanelReportsSubMenuFileCabinet"
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "sidebar-item-icon"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "font-awesome-icon",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "file",
                                                                          "aria-hidden":
                                                                            "true"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "MAIN_CONTENT.FileCabinet.navPanelFileCabinet"
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            : [
                                _c(
                                  "li",
                                  {
                                    staticClass: "treeview",
                                    class: {
                                      active:
                                        _vm.$route.path ===
                                        "/account-settings/general"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.closeSmallMenu()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: "/account-settings/general",
                                          title: _vm.$t(
                                            "MAIN_CONTENT.General.general"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "sidebar-item-icon" },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "cog" }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              _vm.isCollapsed ? "sr-only" : ""
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.General.general"
                                                  )
                                                )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    staticClass: "treeview",
                                    class: {
                                      active:
                                        _vm.$route.path ===
                                        "/account-settings/devices"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.closeSmallMenu()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: "/account-settings/devices",
                                          title: _vm.$t(
                                            "MAIN_CONTENT.Devices.devices"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "sidebar-item-icon" },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "laptop" }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              _vm.isCollapsed ? "sr-only" : ""
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.Devices.devices"
                                                  )
                                                )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.role === "parent"
                                  ? _c(
                                      "li",
                                      {
                                        staticClass: "treeview",
                                        class: {
                                          active:
                                            _vm.$route.path ===
                                            "/account-settings/students"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.closeSmallMenu()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: "/account-settings/students",
                                              title: _vm.$t(
                                                "MAIN_CONTENT.Students.students"
                                              )
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "sidebar-item-icon"
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: { icon: "users" }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class: [
                                                  _vm.isCollapsed
                                                    ? "sr-only"
                                                    : ""
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "MAIN_CONTENT.Students.students"
                                                      )
                                                    )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: {
                                      active:
                                        _vm.$route.path ===
                                        "/account-settings/notifications"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.closeSmallMenu()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: "/account-settings/notifications",
                                          title: _vm.$t(
                                            "MAIN_CONTENT.Notifications.notifications"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "sidebar-item-icon" },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "bell" }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              _vm.isCollapsed ? "sr-only" : ""
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.Notifications.notifications"
                                                  )
                                                )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  {
                                    class: {
                                      active:
                                        _vm.$route.path ===
                                        "/account-settings/third-party-access"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.closeSmallMenu()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to:
                                            "/account-settings/third-party-access",
                                          title: _vm.$t(
                                            "MAIN_CONTENT.thirdPartyAccess.thirdPartyAccess"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "sidebar-item-icon" },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "key" }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              _vm.isCollapsed ? "sr-only" : ""
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "MAIN_CONTENT.thirdPartyAccess.thirdPartyAccess"
                                                  )
                                                )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                        ],
                        2
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.selectedStudent && !_vm.$route.path.includes("account-settings")
            ? _c("students", { attrs: { isCollapsed: _vm.isCollapsed } })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }